import { css } from 'styled-components';

const ShareStyle = css`
  &.social-share-new-pdp {
    width: 190px;
    height: 44px;
    border-radius: 6px;
    box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.25);
    background-color: ${(props) => props.theme.colors.WHITE};
    position: absolute;
    right: 0;
    @media ${(props) => props.theme.mediaQuery.mediumOnly} {
      right: 42px;
    }
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      right: 28px;
    }
  }
  &.share-icon-wrapper-new-pdp {
    width: 41px;
    height: 41px;
    margin: 1px 1px 2px 3px;
    padding: 0 0.1px 0.1px 0;
    opacity: 0.9;
    border-radius: 10px;
    background-color: ${(props) => props.theme.colors.WHITE};
    right: 46px;
    @media ${(props) => props.theme.mediaQuery.large} {
      right: 2px;
      ${(props) => (props.isNewPJPPDPRedesignEnabled ? 'right:-2px;' : '')}
    }
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      right: 30px;
      padding: 0;
      margin: 0;
      ${(props) =>
        props.isNewPJPPDPRedesignEnabled
          ? 'display:flex;justify-content:center;align-items:center'
          : ''}
    }
    position: absolute;
    ${(props) => (props.isNewPJPPDPRedesignEnabled ? 'display:flex;' : '')}
  }
  &.share-icon-wrapper-new-pdp.miniPDP {
    ${(props) => (props.isMiniPDP ? 'display: none;' : '')}
  }
  .share-icon-wrapper-new-pdp.expanded {
    right: 2px;
  }
  .share-icon-new-pdp {
    margin: 5px;
    cursor: pointer;
    svg {
      width: 26px;
      height: 26px;
    }
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      position: absolute;
      right: 0;
      margin: auto;
    }
    @media ${(props) => props.theme.mediaQuery.medium} {
      ${(props) =>
        props.isNewPJPPDPRedesignEnabled ? 'justify-content:center;margin:unset;flex:1;' : ''}
    }
  }

  .share-icon-new-pdp.clear-button {
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      width: unset;
      padding: 0;
      position: unset;
    }
  }

  .social-icons-new-pdp {
    width: 111px;
    height: 25px;
    margin: 0 3px 0 0;
    padding: 9px 17px 10px;
    border-radius: 6px 0 0 6px;
    background-color: ${(props) => props.theme.colors.PRIMARY.PALEGRAY};
  }
  .facebook-new-pdp {
    width: 25px;
    height: 25px;
    cursor: pointer;
  }
  .twitter-new-pdp {
    width: 25px;
    height: 25px;
    cursor: pointer;
    margin-left: 13px;
    margin-right: 18px;
  }
  .pinterest-new-pdp {
    width: 32px;
    height: 25px;
    cursor: pointer;
  }
`;

export default ShareStyle;
